import ImageObject from "../../../../src/mdx/api/schema/image-object.mdx";
import * as React from 'react';
export default {
  ImageObject,
  React
};